import React from 'react';

export default function Faq({ title = 'Frequently Asked Questions', items }) {
  return <section className="bg-[var(--cream)] border-t border-[var(--line)] pb-8" data-testid="faq-section">
    <div className="content-narrow pt-6 pb-2">
      <h2 className="text-center text-[28px] md:text-[29px] font-bold text-[var(--ink)] mb-5">{title}</h2>
      <div className="border border-[var(--line)] rounded-2xl overflow-hidden bg-[var(--paper)]">
        {items.map((f, i) => <details key={f.q} open={i === 0} className="border-b border-[var(--line)] last:border-b-0">
          <summary className="cursor-pointer px-4 py-3 text-[15px] text-slate-800 hover:bg-[var(--brand-soft)]" data-testid={`faq-trigger-${i}`}>{f.q}</summary>
          <p className="px-4 py-5 text-[15px] text-slate-700 bg-[var(--cream)] border-t border-[var(--line)]">{f.a}</p>
        </details>)}
      </div>
    </div>
  </section>;
}
